import React, { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getSubsPlanStart } from "store/SuperAdmin/Authentication/Users/action"
import TableContainer from "components/Common/TableContainer"
import Loader from "common/Loader"
import moment from "moment"
import { CardBody, Col, Row, Badge, Card } from "reactstrap"
import { useParams, useLocation } from "react-router-dom"
import BackButton from "components/Common/BackButton"
const Home = () => {
  const { id } = useParams()
  const location = useLocation()
  const { loading, Subscription } = useSelector(state => state.SuperUser)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getSubsPlanStart(id))
  }, [])

  const columns = useMemo(
    () => [
      {
        Header: "User",
        Cell: cellProps => {
          return <>{location ? location.state.name : ""}</>
        },
      },
      {
        Header: "Start Date",
        accessor: "start_date",
        Cell: cellProps => {
          return <>{moment(cellProps.value).format("DD-MM-YYYY")}</>
        },
      },
      {
        Header: "Expiry Date",
        accessor: "expiry_date",
        Cell: cellProps => {
          return <>{moment(cellProps.value).format("DD-MM-YYYY")}</>
        },
      },
      {
        Header: "Plan",
        accessor: "plan_name",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Payment Mode",
        accessor: "payment_mode",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
    ],
    []
  )
  return (
    <div>
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              {loading ? (
                <Loader />
              ) : (
                <div>
                  <Card>
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <h1 className="mb-0 card-title flex-grow-1">
                          Subscription Status
                        </h1>
                        <BackButton />
                      </div>
                    </CardBody>
                    <CardBody>
                      <TableContainer
                        columns={columns}
                        data={Subscription?.data || []}
                        isGlobalFilter={false}
                        isAddOptions={false}
                        // handleJobClicks={handleJobClicks}
                        isJobListGlobalFilter={false}
                        isPagination={false}
                        iscustomPageSizeOptions={false}
                        isShowingPageLength={false}
                        customPageSize={10}
                        tableClass="table-bordered align-middle nowrap mt-2"
                        paginationDiv="col-sm-12 col-md-7"
                        pagination="pagination justify-content-end pagination-rounded"
                      />
                    </CardBody>
                  </Card>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default Home
